<template>
    <div class="mso_component" style="float:left; position:relative; width:100%; min-height:150px">

      <div v-show="loadMSO" style="position: absolute; width: 100%; height:100%; background-color: #E0F7F7; z-index:99;">
        <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
          <LoadingIcon icon="three-dots" class="loading-icon" />
        </div>
      </div>

      <div v-show="msoError" style="position: absolute; width: 100%; height:100%; background-color: #E0F7F7; z-index:99;">
          <div class="absolute max-w-fit text-center text-gray-500 h-20 pt-10 left-0 right-0 top-0 bottom-0 m-auto">
              ไม่สามารถเชื่อมข้อมูลได้
          </div>
      </div>

      <span style="position: absolute; left:45px;top: 0px; font-size: .8rem; color: var(--blue-text-color); z-index: 2"> สสว {{ indexMSO }} </span>

      <hr :id="'header_line_'+indexMSO" class="absolute" style="margin: -5px 0px .7rem 90px;
          height: 1.5px;
          border-width:0;
          color:#728196;
          background-color:#728196;
          width: calc(100% - 90px);
          top: 15px;
          z-index: 2" />

      <div :id="'my_dataviz' + indexMSO" style="position: relative !important; float:left; overflow:visible; margin:0px 0px 0px 0px; padding:0px;"></div>

    </div>
</template>

<script>
import * as d3 from "d3";
import $ from 'jquery'

export default {
    data() {
        return {
          loading_data: false,
          prepare_data: false,
          msoError: false
        }
    },
    props: {
        indexMSO: Number,
        prefixAmount: String,
        msoData: Object,
        loadMSO: Boolean
    },
    methods: {

    },
    mounted: function (methods, props) {

      // console.log(this.msoData);
      // console.log(this.loadMSO);
      if(!this.loadMSO){

        // console.log('msoData start');
        var max_house_prob = 0;
        var min_house_prob = 0;
        var width_tooltip = 0;
        var height_tooltip = 0;

        let vm = this;
        const index = vm.indexMSO;
        var all_prob = 0;

        var length_line;
        var data_osm_province_list = [];

        var data = vm.msoData;
        var _index = 'osm_' + index;

        var hsize = 36;
        var vheight = 230;
        if(data.osm_province_list[_index] && data.osm_province_list[_index].length > 0){
          vheight = hsize * data.osm_province_list[_index].length;
        }
        // console.log(vheight);

        // set the dimensions and margins of the graph
        var wh = $('.mso_component').width();
        // console.log(wh);

        var margin = { top: 10, right: 0, bottom: 50, left: 40 },
            width = wh - margin.left - margin.right,
            height = vheight - margin.left - margin.right + margin.top;
            // height = vheight - margin.top - margin.bottom;

        // console.log("table width:"+width+" wh:"+wh);

        // const radius = 18;
        var zIndex = 100 - index;

        // append the svg object to the body of the page
        var svg = d3.select("#my_dataviz" + index)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height)
            .style('padding', '0rem 0px')
            .style('z-index', zIndex)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // d3 setting
        var tooltip = d3.select("#tooltip_custom_for_overflow")
            .append("div")
            .attr('class', 'tooltip')
            .style("position", "absolute")
            .style("z-index", "99")
            .style("opacity", 0)
            .style("background", "rgba(255,255,255,.95)")
            .style("border-radius", "5px")
            .style("padding", "10px")
            .style("font-size", ".7rem")
            .style("pointer-events", "none")
            .html("Build tooltip")
            .style("color", "#728196");

        // check
        if(data.osm_province_list[_index] && data.osm_province_list[_index].length > 0){

          if (index == 1) {
              min_house_prob = data.osm_province_list[_index][0].prob_health + data.osm_province_list[_index][0].prob_family + data.osm_province_list[_index][0].prob_education + data.osm_province_list[_index][0].prob_occupation + data.osm_province_list[_index][0].prob_accessibility;
          }
          data_osm_province_list = data.osm_province_list[_index];

          // for get max min

          loadData(data);

          async function loadData(data) {
            // console.log("loadData");
            const get_minmax = await getMinMaxData(data); // get min max data
            if(get_minmax){
              max_house_prob = get_minmax.max;
              min_house_prob = get_minmax.min;
            }
            const donut_data = await setDataDonut(data); // sum total_prop
            const draw_chart = await drawDonut(data); // draw chart
            // console.log("loadData finish");
          }

          function getMinMaxData(data){ // and summary total_prop and get min-max with osm
            var max = 0;
            var min = 0;


            var osm_size = Object.keys(data.osm_province_list).length;
            for (var i = 1; i <= osm_size; i++){
              var _idn = 'osm_'+i;
              data.osm_province_list[_idn].forEach(element => {
                var sum = element.prob_health + element.prob_family + element.prob_education + element.prob_occupation + element.prob_accessibility;
                element.total_prop = sum;
                sum = element.total_prob;
                if (sum > max) {
                  max = sum;
                }
              });
            }

            min = max;
            for (var j = 1; j <= osm_size; j++){
              var _idn = 'osm_'+j;
              data.osm_province_list[_idn].forEach(element => {
                var sum = element.prob_health + element.prob_family + element.prob_education + element.prob_occupation + element.prob_accessibility;
                element.total_prop = sum;
                sum = element.total_prob;
                if (sum < min) {
                  min = sum;
                }
              });
            }

            var maxmin = {
              "max": max,
              "min": min
            }
            return maxmin;
          }

          function setDataDonut(data) {
            data.osm_province_list.osm_1.forEach(element => {
              all_prob = element.prob_health + element.prob_family + element.prob_education + element.prob_occupation + element.prob_accessibility;
              element.prop_total = all_prob;
            });
            return data;
          }

          function drawDonut(data) {
              var _index = 'osm_' + index;
              var _data = data.osm_province_list[_index]; // array

              const sortThaiDictionary = list => {
                const newList = [...list]
                newList.sort((a, b) => a.province_name.localeCompare(b.province_name, 'th'))
                return newList
              }

              var data_use = sortThaiDictionary(_data);

              var y = d3.scaleBand()
                  .range([height, 0])
                  .domain(
                      data_use.map(function (d) {
                          return d.province_name;
                      })
                  )
                  .padding(1);

              // ----------------------------- ชื่อจังหวัด ---------------------------------
              svg.append("g")
                  .attr("transform", "translate(50," + (height) + ")rotate(-90)")
                  .call(d3.axisTop(y))
                  .selectAll("text")
                  .attr("id", function (d, i) {
                      return 'prov_name_' + index + '_' + d;
                  })
                  .attr("font-family", "Kanit")
                  .attr("font-weight", "300")
                  .attr("letter-spacing", ".5")
                  .attr("color", "#728196")
                  .attr("transform", "translate(-10,-12)rotate(90)")
                  .style("text-anchor", "end");

              d3.selectAll(".tick line").attr('stroke-width', '0px');

              // Add Y axis
              // ------------------------- เส้นระดับความสูง ---------------------------
              var x = d3.scaleLinear().domain([100, 0]).range([(width - 100), 0]);
              svg.append("g").call(d3.axisLeft(x))
                  .attr("transform", "translate(50," + (height) + ")rotate(-90)")
                  .text('');
              d3.selectAll(".domain").remove();

              // resize header line
              $("#header_line_"+index).width(width - 60);

              var myColor = d3.scaleOrdinal().range(["#f8a436", "#f68b96", "#7bc573", "#76c9fa", "#a984fa"]);

              // ----------------------------- เส้นประ ---------------------------------
              length_line = svg.selectAll("myline")
                  .data(data_use)
                  .enter()
                  .append("line")
                  .attr("y1", function (d) {
                      return (height - y(d.province_name));
                  })
                  .attr("y2", function (d) {
                      return (height - y(d.province_name));
                  })
                  .attr("x2", function (d) {
                      return (width - 10);
                  })
                  .attr("x1", x(11))
                  .attr("stroke", "grey")
                  .attr("stroke-width", ".5px")
                  .attr("transform", "translate(0,0)rotate(0)")
                  .attr("id", function (d, i) {
                      return 'line_' + d.province_ID;
                  });


              // console.log("check 1");
              // --------------------------- ค่าใน Doughnut --------------------------------
              // ใสค่า เพื่อ plot กราฟ... สำหรับวงกลมหลัง Doughtnut chart
              // console.log("x = & total =");
              // console.log(x);
              // --------------------------- กราฟ Doughnut หัวเส้น --------------------------------

              // delay for varible use
              // setTimeout(function(){
              //   console.log("check round");
              // }, 1000);

              var wrapArc = svg.selectAll('mywarp')
                  .data(data_use)
                  .enter()
                  .append("g")
                  .attr("transform", function (d) {
                      var total = d.total_survey / 100;
                      var percent = (d.total_prob / d.total_survey) * 100;
                      if(percent < 1) percent = 1;
                      const ratio = (d.total_prob / max_house_prob) * 100;
                      var size = (d.total_prob / 100) * ratio;
                      size = size + 2; // circle_size outer
                      var _x = percent * ((width - 60) / 100); // table width 770 ?
                      var _y = height - y(d.province_name);
                      _x = _x + margin.left + 7;
                      // console.log(d.province_name+" total_prob="+d.total_prob+" ="+percent+"% po:"+_x+"/"+width);
                      return "translate(" + _x + "," + _y + ")";
                  })
                  .on("mouseover", mouseover)
                  .on("mouseout", mouseout);
              // .on("click", clicked);

              // console.log("check 3");
              // ------------------------- คำนวณองศา Donut
              // Setup ค่าจุดเริ่มต้น... สำหรับ Doughtnut chart
              let d_angle = 0;
              let d_angle_previous = 0;
              let d_total = 0;
              let current_previous = 0;
              const fullAngle = 2 * Math.PI; // circle angle
              let radius = 18; // circle min size

              var arcGenerator = d3.arc();

              arcGenerator
                  .startAngle(function (d, i) {
                      // console.log(d+" "+i);
                      if (i == 1) {
                          d_angle = d;
                          d_angle_previous = 0;
                      }else if(i == 2){
                          current_previous = d / (d_angle / fullAngle);
                          d_angle_previous = current_previous;
                          // console.log("startAngle index="+i+"="+d+" total="+d_total+" angle="+0+" color="+myColor(i));
                          return 0
                      } else {
                          current_previous = d / (d_angle / fullAngle);
                          var ang = d_angle_previous;
                          d_angle_previous = d_angle_previous + current_previous;
                          // console.log("startAngle index="+i+"="+d+" total="+d_total+" angle="+ang+" color="+myColor(i));
                          return ang;
                      }
                      return 0;
                  })
                  .endAngle(function (d, i) {
                      if (i == 1) {
                        d_angle_previous = 0
                      }
                      var end = d_angle_previous
                      // console.log("endAngle index="+i+" angle="+d_previous);
                      return end;
                      // return d_previous;
                  })
                  .innerRadius(function (d, i) {
                      // max-size = 30
                      const ratio = (d_total / max_house_prob) * 100;
                      if (i == 0) {
                        d_total = d;
                      } else if(i == 1){

                      } else {
                        var size = (radius / 100) * ratio;
                        size = ((size + 2) / 2) + 2; // circle_size inner
                        return size;
                      }
                      // const radius_one_ratio = (max_house_prob - min_house_prob) / (radius);
                      // if (i == 0) {
                      //     d_total = d;
                      // } else {
                      //   var size = d_total / radius_one_ratio;
                      //   if(size < 5) size = 5;
                      //   // console.log("inner : "+d_total +" "+ radius_one_ratio +" = "+ size);
                      //   return size;
                      // }
                  })
                  .outerRadius(function (d, i) {
                      // max-size = 28
                      const ratio = (d_total / max_house_prob) * 100;
                      if (i == 0) {
                        d_total = d;
                      } else if(i == 1){

                      } else {
                        var size = (radius / 100) * ratio;
                        size = size + 2 + 4;
                        return size;
                      }
                      // const radius_one_ratio = (max_house_prob - min_house_prob) / (radius - 10);
                      // if (i == 0) {
                      //     d_total = d;
                      // } else {
                      //   var size = d_total / radius_one_ratio;
                      //   if(size < 2) size = 2;
                      //   // console.log("outer : "+d_total +" "+ radius_one_ratio +" = "+ size);
                      //   return size;
                      // }
                  })
                  .cornerRadius(0);

              // console.log("check 4");

              // ใสค่า เพื่อ plot กราฟ... สำหรับวงกลมหลัง Doughtnut chart
              wrapArc.selectAll("mywrap").data(function (d, i) {
                var array_prob = [d.total_prob, d.total_prop, d.prob_health, d.prob_family, d.prob_education, d.prob_occupation, d.prob_accessibility];
                return array_prob;
              })
              .enter()
              .append("path")
              .attr("d", arcGenerator)
              .attr("stroke", "#e0f7f7")
              .attr("stroke-width", "1px")
              .attr("fill", function (d, i) {
                if (i > 1) { return myColor(i-2); }
              });

              vm.loading_data = false;

              // console.log("check 7");

              var data = d3.range(0, 2 * Math.PI).map(function (t) {
                  return [t, Math.sin(2 * t) * Math.cos(2 * t)];
              });

          }

          function mouseover(d, i) {

              d3.select("#line_" + i.province_ID).attr("stroke-dasharray", "5,5");
              var int = 0, ind = 0;
              data_osm_province_list.forEach(element => {
                  if (element.province_ID + '' == i.province_ID) {
                      ind = int;
                  }
                  int++;
              });
              d3.select("#circle_bg_doughtnut_chart_" + index + '_' + ind)
                  .attr("stroke", "grey")
                  .attr("stroke-dasharray", "4,3")
                  .attr("stroke-width", "1px");
              // console.log("mouseover test 654 #circle_bg_doughtnut_chart_" + index + '_' + ind);
              d3.select("#prov_name_" + index + '_' + i.province_name).attr("font-weight", "bold");

              var _index = i.province_ID;
              // console.log("_index = "+_index);

              // ตัวแปรสำหรับ Tooltip โดนัท
              // console.log("width_tooltip 0");
              // console.log(width_tooltip);
              var display_var = 'flex', width_tooltip = 150, height_tooltip = 150;
              var tooltip_doughtnut_txt_sm = 8, tooltip_doughtnut_txt_lg = 16;
              var height_screen = $(window).height();
              var width_screen = $(window).width();
              var scrollTop = $(window).scrollTop();
              // var scrollLeft = $(window).scrollLeft();

              tooltip.style("display", "block");

              var finalPageX = d.pageX;
              var finalPageY = (d.pageY - 110);

              // ------- ดักความกว้างหน้าจอ Device ---------
              // ------- 1. ดักความกว้างหน้าจอ Mobile ---------
              if ((width_screen / 2) <= 250) {
                  // console.log('in if');
                  display_var = "block";
                  width_tooltip = 200;
                  height_tooltip = 200;
                  tooltip_doughtnut_txt_sm = 12;
                  tooltip_doughtnut_txt_lg = 20;
                  // ------- ดักความกว้างหน้าจอ ---------
                  // ดักกรณีถ้า donut ที่เลือกอยู่ด้านขวา
                  if (d.pageX >= (width_screen / 2)) {
                      finalPageX = finalPageX - 250;
                  }
                  // ดักกรณีถ้า donut ที่เลือกอยู่ด้านซ้าย
                  else {
                      finalPageX = finalPageX;
                  }
                  // ------- ดักความสูงหน้าจอ ---------
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งล่าง
                  if ((d.pageY - scrollTop) >= (height_screen / 2) - 50) {
                      finalPageY = finalPageY - 440;
                  }
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งบน
                  else {
                      finalPageY = finalPageY - 50;
                  }
                  // ------- 2. ดักความกว้างหน้าจอ Desktop ---------
              } else {
                  // console.log("width_tooltip 1");
                  // console.log(width_tooltip);
                  // ------- ดักความกว้างหน้าจอ ---------
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยด้านขวา
                  if (d.pageX >= (width_screen / 2 + (width_tooltip / 2))) {
                      finalPageX = finalPageX - 420;
                  }
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยด้านซ้าย
                  else if (d.pageX <= (width_screen / 2 - (width_tooltip / 2))) {
                      finalPageX = finalPageX;
                  }
                  // ดักกรณีถ้า donut ที่เลือกอยู่กึ่งกลาง
                  else {
                      finalPageX = finalPageX - 230;
                  }
                  // ------- ดักความสูงหน้าจอ ---------
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งล่าง
                  if ((d.pageY - scrollTop) >= (height_screen / 2)) {
                      finalPageY = finalPageY - 190;
                  }
                  // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งบน
                  else {
                      finalPageY = finalPageY;
                  }
              }

              tooltip.style("left", finalPageX + 'px');
              tooltip.style("top", finalPageY + 'px');

              // console.log(display_var);
              // console.log(width_screen);

              tooltip.style("pointer-events", "none");

              var colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';

              tooltip.html("");
              if (d.path) {

                  tooltip.html(`<div style="display: ` + display_var + `">
                                  <div style="display: block; position: relative">
                                      <svg id="mydonut`+ index + `_`+ _index + `" class="myDonut" width="200" height="200"></svg>
                                      <p style="font-size: `+ tooltip_doughtnut_txt_sm + `px; position: absolute; text-align: center; top: 50%;  left: 50%;  transform: translate(-50%, -50%); width: 100%">` + vm.prefixAmount + `ที่ประสบปัญหา<br/><span style="font-size: ` + tooltip_doughtnut_txt_lg + `px">` + millionShortNum(d.path[1].__data__.total_prob) + `</span><br/>` + millionShortString(d.path[1].__data__.total_prob) + '' + vm.prefixAmount + `</p>
                                  </div>
                                  <div style="display: block">
                                      <b style="color: #1d4481">` + d.path[1].__data__.province_name + `</b>
                                      <p>จาก`+ vm.prefixAmount + `ทั้งหมด `+ globalNumDecFixed(d.path[1].__data__.total_survey) + ` ` + vm.prefixAmount + `</p>
                                          <table style="margin-top: .3rem">
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#f8a436") + `</td>
                                              <td>สุขภาพ</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_health) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#f68c96") + `</td>
                                              <td>ความเป็นอยู่</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_family) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#7bc573") + `</td>
                                              <td>การศึกษา</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_education) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#76c9fa") + `</td>
                                              <td>รายได้</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_occupation) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#a984fa") + `</td>
                                              <td>การเข้าถึงบริการรัฐ</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_accessibility) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                      </table>
                                  </div>
                              </div>`);

              } else {

                  tooltip.html(`<div style="display: ` + display_var + `">
                                  <div style="display: block; position: relative">
                                      <svg id="mydonut`+ index + `_`+ _index + `" class="myDonut" width="200" height="200"></svg>
                                      <p style="font-size: 8px; position: absolute; text-align: center; top: 50%;  left: 50%;  transform: translate(-50%, -50%); width: 100%">`+ vm.prefixAmount + `ที่ประสบปัญหา<br/><span style="font-size: 16px">` + millionShortNum(d.target.parentElement.__data__.total_prob) + `</span><br/>` + millionShortString(d.target.parentElement.__data__.total_prob) + '' + vm.prefixAmount + `</p>
                                  </div>
                                  <div style="display: block">
                                      <b style="color: #1d4481">` + d.target.parentElement.__data__.province_name + `</b>
                                      <p>จาก`+ vm.prefixAmount + `ทั้งหมด `+ globalNumDecFixed(d.target.parentElement.__data__.total_survey) + ` ` + vm.prefixAmount + `</p>
                                          <table style="margin-top: .3rem">
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#f8a436") + `</td>
                                              <td>สุขภาพ</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_health) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#f68c96") + `</td>
                                              <td>ความเป็นอยู่</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_family) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#7bc573") + `</td>
                                              <td>การศึกษา</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_education) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#76c9fa") + `</td>
                                              <td>รายได้</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_occupation) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                          <tr>
                                              <td style="min-width: 10px">` + colorSpan("#a984fa") + `</td>
                                              <td>การเข้าถึงบริการรัฐ</td>
                                              <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_accessibility) + `</td>
                                              <td>`+ vm.prefixAmount + `</td>
                                          </tr>
                                      </table>
                                  </div>
                              </div>`);

              }

              // -------------------- กราฟโดนัทใน Tooltip ซ้อนอีกที
              const svg2 = d3.select("#mydonut" + index + "_" + _index).attr("width", width_tooltip).attr("height", height_tooltip);
              const g = svg2.append("g").attr("transform", `translate(${width_tooltip / 2}, ${height_tooltip / 2})`);
              var data = [];

              if (d.path) {
                  data = [d.path[1].__data__.prob_health, d.path[1].__data__.prob_family, d.path[1].__data__.prob_education, d.path[1].__data__.prob_occupation, d.path[1].__data__.prob_accessibility];
              } else {
                  data = [d.target.parentElement.__data__.prob_health, d.target.parentElement.__data__.prob_family, d.target.parentElement.__data__.prob_education, d.target.parentElement.__data__.prob_occupation, d.target.parentElement.__data__.prob_accessibility];
              }

              const radius2 = Math.min(width_tooltip, height_tooltip) / 2;
              const color = d3.scaleOrdinal(['#f8a436', '#f68c96', '#7bc573', '#76c9fa', '#a984fa']);

              const arc = d3
                  .arc()
                  .outerRadius(radius2 - 10)
                  .innerRadius(radius2 - 30);

              const pie = d3.pie().sort(null);
              const pied_data = pie(data);

              const arcs = g
                  .selectAll(".arc")
                  .data(pied_data)
                  .join((enter) => enter.append("path").attr("class", "arc").style("stroke", "white").style("stroke-width", '3px'));

              arcs.attr("d", arc).style("fill", (d, i) => color(i));

              // var circle_svg = d3.select("#mydonut" + index).append("svg")
              //     .attr("width", width_tooltip)
              //     .attr("height", height_tooltip)
              //   .append("g")
              //     .attr("transform", "translate(" + (width_tooltip / 2)+ "," + (height_tooltip / 2) + ")");
              //
              // circle_svg.selectAll('whatever')
              //   .data(data)
              //   .enter()
              //   .append('path')
              //   .attr('d', d3.arc()
              //     .innerRadius(0)
              //     .outerRadius(radius)
              //   )
              //   .attr('fill', function(d, i){ return(color(i)) })
              //   .attr("stroke", "black")
              //   .style("stroke-width", "2px")
              //   .style("opacity", 0.7)

              tooltip.transition().duration(200).style("opacity", 1);
          }

          function mouseout(d, i) {
              d3.select("#line_" + i.province_ID).attr("stroke-dasharray", "5,0");
              var int = 0, ind = 0;
              data_osm_province_list.forEach(element => {
                  if (element.province_ID + '' == i.province_ID) {
                      ind = int;
                  }
                  int++;
              });
              d3.select("#circle_bg_doughtnut_chart_" + index + '_' + ind)
                  .attr("stroke", "none")
                  .attr("stroke-dasharray", "4,3")
                  .attr("stroke-width", "0px");
              d3.select("#prov_name_" + index + '_' + i.province_name).attr("font-weight", "300");

              // ---------- Hide tooltip
              tooltip.html("");
              tooltip.transition().duration(200).style("opacity", 0);
              tooltip.style("display", "none");
          }

          function globalNumDecFixed(num, dec_amount) {
              if (!(num % 1)) {
                  dec_amount = 0;
              }
              return new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: dec_amount,
              }).format(Number.parseFloat(num).toFixed(dec_amount));
          }

          function globalRandom(max_ran, min_ran, dec_amount = 0) {
              var new_ran = Math.random() * (max_ran - min_ran) + min_ran;
              new_ran = new_ran + Math.random() * 99999 * 0.00001;
              return globalNumDecFixed(new_ran, dec_amount);
          }

          function millionShortNum(num) {
              // console.log(num);
              // console.log('num');
              num = parseInt(num);
              if (num >= 1000000000000000000000000) {
                  return globalNumDecFixed(
                      (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                      2
                  );
              }
              if (num >= 1000000000000000000) {
                  return globalNumDecFixed(
                      (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                      2
                  );
              }
              if (num >= 1000000000000) {
                  return globalNumDecFixed((num / 1000000000000)
                      .toFixed(2)
                      .replace(/\.0$/, ""), 2);
              }
              if (num >= 1000000) {
                  return globalNumDecFixed((num / 1000000)
                      .toFixed(2)
                      .replace(/\.0$/, ""), 2);
              }
              if (num < 1000000) {
                  return globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 3);
              }
              return globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
          }

          function millionShortString(num) {
              if (num >= 1000000000000000000000000) {
                  return "ล้านล้านล้านล้าน";
              }
              if (num >= 1000000000000000000) {
                  return "ล้านล้านล้าน";
              }
              if (num >= 1000000000000) {
                  return "ล้านล้าน";
              }
              if (num >= 1000000) {
                  return "ล้าน";
              }
              return '';
          }

        }

        // d3.json("/1_all_province_5dim_donut_edit2.json")
        //     .then(function (data) {
        //         var _index = 'osm_' + index;
        //
        //
        //         mypromise().then((res) => {
        //             // console.log(min_house_prob + ' : ' + max_house_prob);
        //         }).catch((error) => {
        //             console.log(`Handling error as we received ${error}`);
        //         });
        //     })
        //     .catch(function (error) {
        //         console.log("error catch", error); // displays 404 error if file not found
        //     });
        //
        // // set the dimensions and margins of the graph
        // var margin = { top: 10, right: 0, bottom: 50, left: 40 },
        //     width = 770 - margin.left - margin.right,
        //     height = 230 - margin.top - margin.bottom;
        // const radius = 25;
        //
        // // append the svg object to the body of the page
        // var svg = d3
        //     .select("#my_dataviz" + index)
        //     .append("svg")
        //     .attr("width", width + margin.left + margin.right)
        //     .attr("height", height + margin.top + margin.bottom)
        //     .style('padding', '1rem 0px')
        //     .append("g")
        //     .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        //
        // d3.json("/1_all_province_5dim_donut_edit2.json")
        //     .then(function (data) {
        //         data.osm_province_list.osm_1.forEach(element => {
        //             all_prob = element.prob_health + element.prob_family + element.prob_education + element.prob_occupation + element.prob_accesibility;
        //             element.prop_total = all_prob;
        //         });
        //     })
        //     .catch(function (error) {
        //         console.log("error 2", error); // displays 404 error if file not found
        //     });
        //
        // // Parse the Data
        // d3.json("/1_all_province_5dim_donut_edit2.json")
        //     .then(function (data) {
        //         // X axis
        //         var _index = 'osm_' + index;
        //         var data_use = data.osm_province_list[_index];
        //         var y = d3
        //             .scaleBand()
        //             .range([height, 0])
        //             .domain(
        //                 data.osm_province_list[_index].map(function (d) {
        //                     return d.province_name;
        //                 })
        //             )
        //             .padding(1);
        //
        //         // ----------------------------- ชื่อจังหวัด ---------------------------------
        //         svg
        //             .append("g")
        //             .attr("transform", "translate(50," + (height) + ")rotate(-90)")
        //             .call(d3.axisTop(y))
        //             .selectAll("text")
        //             .attr("id", function (d, i) {
        //                 return 'prov_name_' + index + '_' + d;
        //             })
        //             .attr("font-family", "Kanit")
        //             .attr("font-weight", "300")
        //             .attr("letter-spacing", ".5")
        //             .attr("color", "#728196")
        //             .attr("transform", "translate(-10,-12)rotate(90)")
        //             .style("text-anchor", "end");
        //
        //         d3.selectAll(".tick line").attr('stroke-width', '0px');
        //
        //         // Add Y axis
        //         // ------------------------- เส้นระดับความสูง ---------------------------
        //         var x = d3.scaleLinear().domain([100, 0]).range([(width - 100), 0]);
        //         svg.append("g").call(d3.axisLeft(x))
        //             .attr("transform", "translate(50," + (height) + ")rotate(-90)")
        //             .text('');
        //         d3.selectAll(".domain").remove();
        //
        //         var myColor = d3
        //             .scaleOrdinal()
        //             .range([
        //                 "#f8a436",
        //                 "#f68b96",
        //                 "#7bc573",
        //                 "#76c9fa",
        //                 "#a984fa"
        //             ]);
        //
        //         // ----------------------------- เส้นประ ---------------------------------
        //         var test_data_promise1 = data.osm_province_list[_index];
        //         var test_data_promise2 = data.osm_province_list[_index];
        //
        //         let mypromise2 = function functionOne() {
        //             return new Promise((resolve, reject) => {
        //                 test_data_promise2 = [...test_data_promise2].reverse();
        //                 if (test_data_promise1 != test_data_promise2) {
        //                     resolve("Resolved");
        //                 } else {
        //                     reject("Rejected")
        //                 }
        //             });
        //         };
        //
        //         mypromise2().then((res) => {
        //             length_line = svg
        //                 .selectAll("myline")
        //                 .data(test_data_promise1)
        //                 .enter()
        //                 .append("line")
        //                 .attr("y1", function (d) {
        //                     return (height - y(d.province_name));
        //                 })
        //                 .attr("y2", function (d) {
        //                     return (height - y(d.province_name));
        //                 })
        //                 .attr("x2", function (d) {
        //                     return (width - 10);
        //                 })
        //                 .attr("x1", x(8))
        //                 .attr("stroke", "grey")
        //                 .attr("stroke-width", ".5px")
        //                 .attr("transform", "translate(0,0)rotate(0)")
        //                 .attr("id", function (d, i) {
        //                     return 'line_' + d.province_ID;
        //                 });
        //         }).catch((error) => {
        //             console.log(`Handling error as we received ${error}`);
        //         });
        //
        //         // --------------------------- ค่าใน Doughnut --------------------------------
        //         // ใสค่า เพื่อ plot กราฟ... สำหรับวงกลมหลัง Doughtnut chart
        //         setTimeout(() => {
        //             // --------------------------- กราฟ Doughnut หัวเส้น --------------------------------
        //             var wrapArc = svg
        //                 .selectAll('mywarp')
        //                 .data(data_use)
        //                 .enter()
        //                 .append("g")
        //                 .attr("transform", function (d) {
        //                     var total = d.total_survey / 100;
        //                     return "translate(" + x(((d.prob_health + d.prob_family + d.prob_education + d.prob_occupation + d.prob_accesibility) / total) + 7) + "," + (height - y(d.province_name)) + ")";
        //                 })
        //                 .on("mouseover", mouseover)
        //                 .on("mouseout", mouseout);
        //             // .on("click", clicked);
        //
        //             // ------------------------- คำนวณองศา Donut
        //             // Setup ค่าจุดเริ่มต้น... สำหรับ Doughtnut chart
        //             var d_total = 0, d_previous = 0, current_previous = 0;
        //             var arcGenerator = d3.arc();
        //             const fullAngle = 2 * Math.PI;
        //             var makeSegments = arcGenerator
        //                 .startAngle(function (d, i) {
        //                     if (i == 0) {
        //                         d_total = d;
        //                     } else if (i == 1) {
        //                         d_previous = d;
        //                         return 0;
        //                     } else {
        //                         current_previous = d_previous / (d_total / fullAngle);
        //                         d_previous = d + d_previous;
        //                         return current_previous;
        //                     }
        //                 })
        //                 .endAngle(function (d, i) {
        //                     if (i == 0) {
        //                         d_total = d;
        //                     } else if (i == 1) {
        //                         d_previous = d;
        //                         return d / (d_total / fullAngle);
        //                     } else {
        //                         current_previous = d_previous / (d_total / fullAngle);
        //                         return current_previous;
        //                     }
        //                 })
        //                 .innerRadius(function (d, i) {
        //                     const radius_one_ratio = (max_house_prob - min_house_prob) / (radius - 18);
        //                     if (i == 0) {
        //                         d_total = d;
        //                     } else {
        //                         return d_total / radius_one_ratio;
        //                     }
        //                 })
        //                 .outerRadius(function (d, i) {
        //                     const radius_one_ratio = (max_house_prob - min_house_prob) / (radius - 12);
        //                     if (i == 0) {
        //                         d_total = d;
        //                     } else {
        //                         return d_total / radius_one_ratio;
        //                     }
        //                 })
        //                 .cornerRadius(0);
        //
        //             // Setup ค่าจุดเริ่มต้น... สำหรับวงกลมหลัง Doughtnut chart
        //             var arcGenerator2 = d3.arc();
        //             var makeSegments = arcGenerator2
        //                 .startAngle(function (d, i) {
        //                     return 0;
        //                 })
        //                 .endAngle(function (d, i) {
        //                     return 360;
        //                 })
        //                 .innerRadius(function (d, i) {
        //                     return 0;
        //                 })
        //                 .outerRadius(function (d, i) {
        //                     const radius_one_ratio = (max_house_prob - min_house_prob) / (radius - 11);
        //                     if (i == 0) {
        //                         d_total = d;
        //                     } else {
        //                         return d_total / radius_one_ratio;
        //                     }
        //                 })
        //                 .cornerRadius(0);
        //
        //             var arcSeg2 = wrapArc
        //                 .selectAll("mywrap")
        //                 .data(function (d, i) {
        //                     var array_prob = [d.prob_total, d.prob_health, d.prob_family, d.prob_education, d.prob_occupation, d.prob_accesibility];
        //                     return array_prob;
        //                 })
        //                 .enter()
        //                 .append("path")
        //                 .attr("d", arcGenerator2)
        //                 .attr("id", function (d, i) {
        //                     return 'circle_bg_doughtnut_chart_' + index + '_' + i;
        //                 })
        //                 .attr("fill", '#e0f7f7');
        //
        //             // ใสค่า เพื่อ plot กราฟ... สำหรับวงกลมหลัง Doughtnut chart
        //             var arcSeg = wrapArc
        //                 .selectAll("mywrap")
        //                 .data(function (d, i) {
        //                     var array_prob = [d.prob_total, d.prob_health, d.prob_family, d.prob_education, d.prob_occupation, d.prob_accesibility];
        //                     return array_prob;
        //                 })
        //                 .enter()
        //                 .append("path")
        //                 .attr("d", arcGenerator)
        //                 .attr("stroke", "#e0f7f7")
        //                 .attr("stroke-width", "1px")
        //                 .attr("fill", function (d, i) {
        //                     if (i != 0) { return myColor(i); }
        //                 });
        //         }, 100, data_use);
        //
        //         vm.prepare_data = true;
        //         // console.log(prepare_data);
        //
        //         var data = d3.range(0, 2 * Math.PI).map(function (t) {
        //             return [t, Math.sin(2 * t) * Math.cos(2 * t)];
        //         });
        //     })
        //     .catch(function (error) {
        //         console.log("error 2", error); // displays 404 error if file not found
        //     });
        //
        // function mouseover(d, i) {
        //     d3.select("#line_" + i.province_ID).attr("stroke-dasharray", "5,5");
        //     var int = 0, ind = 0;
        //     data_osm_province_list.forEach(element => {
        //         if (element.province_ID == i.province_ID) {
        //             ind = int;
        //         }width_tooltip
        //         int++;
        //     });
        //     d3.select("#circle_bg_doughtnut_chart_" + index + '_' + ind)
        //         .attr("stroke", "grey")
        //         .attr("stroke-dasharray", "4,3")
        //         .attr("stroke-width", "1px");
        //     // console.log("mouseover test 654 #circle_bg_doughtnut_chart_" + index + '_' + ind);
        //     d3.select("#prov_name_" + index + '_' + i.province_name).attr("font-weight", "bold");
        //
        //     // ตัวแปรสำหรับ Tooltip โดนัท
        //     var display_var = 'flex', width_tooltip = 150, height_tooltip = 150;
        //     var tooltip_doughtnut_txt_sm = 8, tooltip_doughtnut_txt_lg = 16;
        //     var height_screen = $(window).height();
        //     var width_screen = $(window).width();
        //     var scrollTop = $(window).scrollTop();
        //     // var scrollLeft = $(window).scrollLeft();
        //
        //     tooltip.style("display", "block");
        //
        //     var finalPageX = d.pageX;
        //     var finalPageY = (d.pageY - 110);
        //
        //     // ------- ดักความกว้างหน้าจอ Device ---------
        //     // ------- 1. ดักความกว้างหน้าจอ Mobile ---------
        //     if ((width_screen / 2) <= 250) {
        //         // console.log('in if');
        //         display_var = "block";
        //         width_tooltip = 200;
        //         height_tooltip = 200;
        //         tooltip_doughtnut_txt_sm = 12;
        //         tooltip_doughtnut_txt_lg = 20;
        //         // ------- ดักความกว้างหน้าจอ ---------
        //         // ดักกรณีถ้า donut ที่เลือกอยู่ด้านขวา
        //         if (d.pageX >= (width_screen / 2)) {
        //             finalPageX = finalPageX - 250;
        //         }
        //         // ดักกรณีถ้า donut ที่เลือกอยู่ด้านซ้าย
        //         else {
        //             finalPageX = finalPageX;
        //         }
        //         // ------- ดักความสูงหน้าจอ ---------
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งล่าง
        //         if ((d.pageY - scrollTop) >= (height_screen / 2) - 50) {
        //             finalPageY = finalPageY - 440;
        //         }
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งบน
        //         else {
        //             finalPageY = finalPageY - 50;
        //         }
        //         // ------- 2. ดักความกว้างหน้าจอ Desktop ---------
        //     } else {
        //         // ------- ดักความกว้างหน้าจอ ---------
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยด้านขวา
        //         if (d.pageX >= (width_screen / 2 + (width_tooltip / 2))) {
        //             finalPageX = finalPageX - 420;
        //         }
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยด้านซ้าย
        //         else if (d.pageX <= (width_screen / 2 - (width_tooltip / 2))) {
        //             finalPageX = finalPageX;
        //         }
        //         // ดักกรณีถ้า donut ที่เลือกอยู่กึ่งกลาง
        //         else {
        //             finalPageX = finalPageX - 230;
        //         }
        //         // ------- ดักความสูงหน้าจอ ---------
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งล่าง
        //         if ((d.pageY - scrollTop) >= (height_screen / 2)) {
        //             finalPageY = finalPageY - 190;
        //         }
        //         // ดักกรณีถ้า donut ที่เลือกอยู่เลยครึ่งบน
        //         else {
        //             finalPageY = finalPageY;
        //         }
        //     }
        //
        //     tooltip.style("left", finalPageX + 'px');
        //     tooltip.style("top", finalPageY + 'px');
        //
        //     // console.log(display_var);
        //     // console.log(width_screen);
        //
        //     tooltip.style("pointer-events", "none");
        //
        //     var colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
        //     if (d.path) {
        //         tooltip.html(`<div style="display: ` + display_var + `">
        //                         <div style="display: block; position: relative">
        //                             <svg id="mydonut`+ index + `" class="myDonut" width="200" height="200"></svg>
        //                             <p style="font-size: `+ tooltip_doughtnut_txt_sm + `px; position: absolute; text-align: center; top: 50%;  left: 50%;  transform: translate(-50%, -50%); width: 100%">` + vm.prefixAmount + `ที่ประสบปัญหา<br/><span style="font-size: ` + tooltip_doughtnut_txt_lg + `px">` + millionShortNum(d.path[1].__data__.prob_total) + `</span><br/>` + millionShortString(d.path[1].__data__.prob_total) + '' + vm.prefixAmount + `</p>
        //                         </div>
        //                         <div style="display: block">
        //                             <b style="color: #1d4481">` + d.path[1].__data__.province_name + `</b>
        //                             <p>จากครัวเรือนทั้งหมด `+ globalNumDecFixed(d.path[1].__data__.prob_total) + ` ` + vm.prefixAmount + `</p>
        //                                 <table style="margin-top: .3rem">
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#f8a436") + `</td>
        //                                     <td>สุขภาพ</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_health) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#f68c96") + `</td>
        //                                     <td>ความเป็นอยู่</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_family) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#7bc573") + `</td>
        //                                     <td>การศึกษา</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_education) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#76c9fa") + `</td>
        //                                     <td>รายได้</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_occupation) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#a984fa") + `</td>
        //                                     <td>การเข้าถึงบริการรัฐ</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.path[1].__data__.prob_accesibility) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                             </table>
        //                         </div>
        //                     </div>`);
        //     } else {
        //         tooltip.html(`<div style="display: ` + display_var + `">
        //                         <div style="display: block; position: relative">
        //                             <svg id="mydonut`+ index + `" class="myDonut" width="200" height="200"></svg>
        //                             <p style="font-size: 8px; position: absolute; text-align: center; top: 50%;  left: 50%;  transform: translate(-50%, -50%); width: 100%">`+ vm.prefixAmount + `ที่ประสบปัญหา<br/><span style="font-size: 16px">` + millionShortNum(d.target.parentElement.__data__.prob_total) + `</span><br/>` + millionShortString(d.target.parentElement.__data__.prob_total) + '' + vm.prefixAmount + `</p>
        //                         </div>
        //                         <div style="display: block">
        //                             <b style="color: #1d4481">` + d.target.parentElement.__data__.province_name + `</b>
        //                             <p>จากครัวเรือนทั้งหมด `+ globalNumDecFixed(d.target.parentElement.__data__.prob_total) + ` ` + vm.prefixAmount + `</p>
        //                                 <table style="margin-top: .3rem">
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#f8a436") + `</td>
        //                                     <td>สุขภาพ</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_health) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#f68c96") + `</td>
        //                                     <td>ความเป็นอยู่</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_family) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#7bc573") + `</td>
        //                                     <td>การศึกษา</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_education) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#76c9fa") + `</td>
        //                                     <td>รายได้</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_occupation) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td style="min-width: 10px">` + colorSpan("#a984fa") + `</td>
        //                                     <td>การเข้าถึงบริการรัฐ</td>
        //                                     <td style="text-align: right">` + globalNumDecFixed(d.target.parentElement.__data__.prob_accesibility) + `</td>
        //                                     <td>`+ vm.prefixAmount + `</td>
        //                                 </tr>
        //                             </table>
        //                         </div>
        //                     </div>`);
        //     }
        //
        //     // -------------------- กราฟโดนัทใน Tooltip ซ้อนอีกที
        //     const svg2 = d3.select("#mydonut" + index).attr("width", width_tooltip).attr("height", height_tooltip);
        //     const g = svg2.append("g").attr("transform", `translate(${width_tooltip / 2}, ${height_tooltip / 2})`);
        //     var data = [];
        //     if (d.path) {
        //         data = [d.path[1].__data__.prob_health, d.path[1].__data__.prob_family, d.path[1].__data__.prob_education, d.path[1].__data__.prob_occupation, d.path[1].__data__.prob_accesibility];
        //     } else {
        //         data = [d.target.parentElement.__data__.prob_health, d.target.parentElement.__data__.prob_family, d.target.parentElement.__data__.prob_education, d.target.parentElement.__data__.prob_occupation, d.target.parentElement.__data__.prob_accesibility];
        //     }
        //     const radius2 = Math.min(width_tooltip, height_tooltip) / 2;
        //     const color = d3.scaleOrdinal(['#f8a436', '#f68c96', '#7bc573', '#76c9fa', '#a984fa']);
        //     const arc = d3
        //         .arc()
        //         .outerRadius(radius2 - 10)
        //         .innerRadius(radius2 - 30);
        //     const pie = d3.pie().sort(null);
        //     const pied_data = pie(data);
        //     const arcs = g
        //         .selectAll(".arc")
        //         .data(pied_data)
        //         .join((enter) => enter.append("path").attr("class", "arc").style("stroke", "white").style("stroke-width", '3px'));
        //     arcs.attr("d", arc).style("fill", (d, i) => color(i));
        //
        //     tooltip.transition().duration(200).style("opacity", 1);
        // }
        //
        // function mouseout(d, i) {
        //     d3.select("#line_" + i.province_ID).attr("stroke-dasharray", "5,0");
        //     var int = 0, ind = 0;
        //     data_osm_province_list.forEach(element => {
        //         if (element.province_ID == i.province_ID) {
        //             ind = int;
        //         }
        //         int++;
        //     });
        //     d3.select("#circle_bg_doughtnut_chart_" + index + '_' + ind)
        //         .attr("stroke", "none")
        //         .attr("stroke-dasharray", "4,3")
        //         .attr("stroke-width", "0px");
        //     d3.select("#prov_name_" + index + '_' + i.province_name).attr("font-weight", "300");
        //
        //     // ---------- Hide tooltip
        //     tooltip.transition().duration(200).style("opacity", 0);
        //     tooltip.style("display", "none");
        // }
        //
        // function globalNumDecFixed(num, dec_amount) {
        //     if (!(num % 1)) {
        //         dec_amount = 0;
        //     }
        //     return new Intl.NumberFormat("en-US", {
        //         minimumFractionDigits: dec_amount,
        //     }).format(Number.parseFloat(num).toFixed(dec_amount));
        // }
        //
        // function globalRandom(max_ran, min_ran, dec_amount = 0) {
        //     var new_ran = Math.random() * (max_ran - min_ran) + min_ran;
        //     new_ran = new_ran + Math.random() * 99999 * 0.00001;
        //     return globalNumDecFixed(new_ran, dec_amount);
        // }
        //
        // function millionShortNum(num) {
        //     if (num >= 1000000000000000000000000) {
        //         return globalNumDecFixed(
        //             (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
        //             2
        //         );
        //     }
        //     if (num >= 1000000000000000000) {
        //         return globalNumDecFixed(
        //             (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
        //             2
        //         );
        //     }
        //     if (num >= 1000000000000) {
        //         return globalNumDecFixed((num / 1000000000000)
        //             .toFixed(2)
        //             .replace(/\.0$/, ""), 2);
        //     }
        //     if (num >= 1000000) {
        //         return globalNumDecFixed((num / 1000000)
        //             .toFixed(2)
        //             .replace(/\.0$/, ""), 2);
        //     }
        //     return globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        // }
        //
        // function millionShortString(num) {
        //     if (num >= 1000000000000000000000000) {
        //         return "ล้านล้านล้านล้าน";
        //     }
        //     if (num >= 1000000000000000000) {
        //         return "ล้านล้านล้าน";
        //     }
        //     if (num >= 1000000000000) {
        //         return "ล้านล้าน";
        //     }
        //     if (num >= 1000000) {
        //         return "ล้าน";
        //     }
        //     return '';
        // }

      }

    },
}
</script>
